import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-wf-clock",
  "use": "icon-soc-wf-clock-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-wf-clock\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"512\" cy=\"512\" r=\"320\" /><circle cx=\"512\" cy=\"512\" r=\"48\" fill=\"#fff\" /><path d=\"M488 288h48v240h-48z\" fill=\"#fff\" /><path d=\"M512 488l176 96-24 40-152-84z\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-wf-clock.svg
// module id = LlHR
// module chunks = 491